import { Modal } from '@/components/Modal';
import type { PaymentInstalmentRow } from '../columns/payment-instalments-columns';
import { PaymentScheduleTable } from './PaymentScheduleTable';

interface PaymentScheduleDetailModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rows: PaymentInstalmentRow[];
  hasInstrumentNumber: boolean;
  recurrenceLabel: string;
}

// Read-only: the instalments are already règlements in Treasury, some possibly deposited, so they
// are not editable from here.
export function PaymentScheduleDetailModal(props: PaymentScheduleDetailModalProps) {
  const { open, onOpenChange, rows, hasInstrumentNumber, recurrenceLabel } = props;

  return (
    <Modal title="Échéancier" open={open} onOpenChange={onOpenChange}>
      <p className="text-sm text-gray-500">{recurrenceLabel}</p>
      <PaymentScheduleTable rows={rows} hasInstrumentNumber={hasInstrumentNumber} />
    </Modal>
  );
}
